import React, { FC } from "react";
import { ActionSection } from "../ActionSection";

/** Action section for use with Wizard component */
export const WizardButtons: FC = ({ children }) => {
  return <ActionSection includeBorder>{children}</ActionSection>;
};
